<template>
    <div class="main" >
        <div v-if="loading" class="loading-form" style="min-height: 130px;">
            <img src="/public/img/loading-bar.gif" />
        </div>
        <div v-else>
            <template>
                <c-panel >
                    <turmas 
                        v-if="step == 1" 
                        :param="dados"
                    />
                    <disciplinas 
                        v-if="step == 2" 
                        :param="dados"
                        :turmaSelected="turmaSelected"
                    />
                    <alunos 
                        v-if="step == 3" 
                        :turmaSelected="turmaSelected"
                        :dataSelected="form.data"
                        :horariosSelected="form.horarios"
                        @notaCadastrada="notaCadastrada"
                    />
                </c-panel>
            </template>
        </div>
    </div>
</template>
<script>

import turmas from "./turmas"
import disciplinas from "./disciplinas"
import alunos from "./alunos"

export default {
    components:{ 
        turmas,
        disciplinas,
        alunos
    },
    data () {
        return {
            loading: true,
            dados: {},
            step: 1,
            form: {
                data: '',
                turma: '',
                disciplina: '',
                alunos: []
            },
            turmaSelected: {}

        }
    },
    mounted () {

        this.initFormNotas();
    },
    methods:{
        async initFormNotas(){

            this.loading = true;

            let i = this.$store.state.config.instituicao.id;
            let p = this.$store.state.config.periodo.id;

            let response = await this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/notas/initFormNotas/${i}/${p}`, this.$store.getters.getHeaderAuth);
            
            console.log(response.data);
           
            this.dados = JSON.parse(JSON.stringify(response.data));

        //     this.changeRota();

            this.loading = false;
        },
        notaCadastrada(alunos){

            this.form.alunos = alunos;
            this.onSubmitFrequencia();
        },
        async onSubmitFrequencia(){

            let response = await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/frequencia/storeFrequencia`, this.form, this.$store.getters.getHeaderAuth);

            if(typeof response.data.erro !== 'undefined'){

                window.eventBus.$emit('loading', false);
                window.eventBus.$emit('alert', {msg: response.data.erro, type: 'warning'});

            }else{

                window.eventBus.$emit('loading', false);
                window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                this.form =  {
                    data: '',
                    turma: '',
                    disciplina: '',
                    horarios: [],
                    alunos: []
                };

                this.$router.push(`/admin`);  
            }

        },        
        changeRota(){

            this.form =  {
                turma: '',
                disciplina: '',
                alunos: []
            };

            if(!this.$route.query['data'] && !this.$route.query['turma'] && !this.$route.query['disciplina'] && !this.$route.query['horarios']){
                for(let i in this.dados.datas){
                    if(this.dados.datas[i] == this.$moment().format('YYYY-MM-DD')){
                        this.showCardAcao = true;
                    }
                }
                this.step = 1;
            }

            if(this.$route.query['data']){
                this.step = 2;
                this.showCardAcao = false;
                this.form.data = this.$route.query['data'];
            }

            if(this.$route.query['turma']){                  

                for(let i in this.dados.turmas){
                    if(this.dados.turmas[i].id == this.$route.query['turma']){
                        this.turmaSelected = this.dados.turmas[i];
                    }
                }

                this.form.turma = this.$route.query['turma'];

                if(this.turmaSelected.qtd_horarios == 1){

                    this.form.disciplina = 'f1';
                    this.form.horarios = [];

                    this.showCardAcao = false;
                    this.step = 5;

                }else{

                    this.showCardAcao = false;
                    this.step = 3;
                }
            }

            if(this.$route.query['disciplina']){
                this.showCardAcao = false;
                this.step = 4;
                this.form.disciplina = this.$route.query['disciplina'];
            }
            
            if(this.$route.query['horarios']){
                this.showCardAcao = false;
                this.step = 5;
                this.form.horarios = this.$route.query['horarios'].split(",");
            }

            
        }
    },
    watch: {
        '$route.query': {
            handler (value) {
                this.changeRota();
            }
        },
    }
    
}
</script>
<style>
    .card-registro-frequencia {
        height: 85vh;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
    .card-registro-frequencia .level {
        width: 500px;
    }
</style>
